import { i18n, type MessageKey } from 'shared/i18n';
import LanguageIcon from 'shared/ui/LanguageIcon';
import Dropdown from 'shared/forms/Dropdown';

export const langs: { lang: string; name: string; labelKey: MessageKey; locale: string; systemLang: boolean }[] = [
  { lang: 'sv', name: 'Svenska', labelKey: 'lang:sv', locale: 'sv-SE', systemLang: true },
  { lang: 'en', name: 'Engelska', labelKey: 'lang:en', locale: 'en-US', systemLang: true },
];

interface LanguageSelectorProps {
  disabled?: boolean;
  onChange?: (locale: string) => void;
  locale?: string;
  sm?: boolean;
}

const LanguageSelector = ({ disabled = false, onChange, locale, sm }: LanguageSelectorProps) => {
  const items = langs.map((lang) => ({ value: lang.locale, title: i18n(lang.labelKey), icon: <LanguageIcon language={lang.lang} /> }));

  const handleSelectLanguage = (lang: unknown) => {
    if (typeof lang === 'string') onChange?.(lang);
  };

  return <Dropdown sm={sm} disabled={disabled} value={locale} onChange={handleSelectLanguage} items={items} />;
};

export default LanguageSelector;
